import CookiesModal from './CookiesModal';

export default CookiesModal;